import { Platform, StyleSheet } from 'react-native';
import { colors, spacing } from '@pletly/ui';

const PADDING_TOP = Platform.select({ web: spacing(3), default: spacing(2.5) });
const BG_COLOR = Platform.select({ web: 'transparent', default: colors.background });

export const styles = StyleSheet.create({
	scrollContainer: {
		backgroundColor: BG_COLOR,
		paddingTop: PADDING_TOP,
	},
	bottomGutter: {
		paddingBottom: spacing(9),
	},
	columnRight: {
		paddingTop: PADDING_TOP,
	},
	listStyle: {
		width: '100%',
	},
});
